/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppendixResource
 */
export interface AppendixResource {
    /**
     * 
     * @type {boolean}
     * @memberof AppendixResource
     */
    canBeAdded: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppendixResource
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof AppendixResource
     */
    fileUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof AppendixResource
     */
    uploadedDate?: Date;
}

/**
 * Check if a given object implements the AppendixResource interface.
 */
export function instanceOfAppendixResource(value: object): value is AppendixResource {
    if (!('canBeAdded' in value) || value['canBeAdded'] === undefined) return false;
    return true;
}

export function AppendixResourceFromJSON(json: any): AppendixResource {
    return AppendixResourceFromJSONTyped(json, false);
}

export function AppendixResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppendixResource {
    if (json == null) {
        return json;
    }
    return {
        
        'canBeAdded': json['canBeAdded'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'uploadedDate': json['uploadedDate'] == null ? undefined : (new Date(json['uploadedDate'])),
    };
}

export function AppendixResourceToJSON(value?: AppendixResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'canBeAdded': value['canBeAdded'],
        'fileName': value['fileName'],
        'fileUrl': value['fileUrl'],
        'uploadedDate': value['uploadedDate'] == null ? undefined : ((value['uploadedDate']).toISOString()),
    };
}

